import React from 'react'

const Button = (props) => {
    const { 
        onClick,
        className,
        children,
    } = props
    return (
        <a className={`certification__button ${className}`} onClick={onClick}>
            {children}
        </a>
    )
}

export default Button